
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agencies",
      function () {
        return require("private-next-pages/agencies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agencies"])
      });
    }
  